import axios from "axios";
import API_BASE_URL from '../../config';
import LoginExternalServices from "../loginexternalservices/LoginExternalServices";
// import AuthServices from './AuthServices.js';

export const RegisterExternalServices = async (userData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}api/user-register-external/`, userData);


        console.log(response);

        // si la peticion es 200: ok redirigimos al login
        if (response.status === 201) {
            console.log(response.status === 201)
            const ciam_id = userData['ciam_id']

            // llamamos la peticion del login nuevamente
            // await LoginExternalServices(ciam_id)
            return response.data;
        }

        if (response.status === 400) {

            console.log(response);
            return response;
        }

    } catch (error) {
        console.error(error)
    }
}